import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "pophead"
};
const _hoisted_2 = {
  class: "phleft"
};
const _hoisted_3 = {
  class: "title"
};
const _hoisted_4 = {
  class: "popcontent"
};
const _hoisted_5 = {
  class: "popconleft"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  class: "popconright"
};
const _hoisted_8 = {
  class: "innerbox"
};
const _hoisted_9 = {
  class: "imgcontent"
};
const _hoisted_10 = {
  class: "swiper-wrapper"
};
const _hoisted_11 = ["src"];
const _hoisted_12 = {
  class: "otherdesc"
};
const _hoisted_13 = {
  key: 0
};
const _hoisted_14 = {
  key: 1
};
const _hoisted_15 = ["href"];
const _hoisted_16 = {
  class: "textcontainer"
};
const _hoisted_17 = ["innerHTML"];
const _hoisted_18 = {
  class: "innerbox"
};
const _hoisted_19 = {
  key: 0,
  class: "ul2"
};
const _hoisted_20 = ["onClick"];
const _hoisted_21 = {
  href: "javascript:void(0)"
};
const _hoisted_22 = {
  class: "imgbox"
};
const _hoisted_23 = ["src"];
const _hoisted_24 = {
  class: "innerdetail"
};
const _hoisted_25 = {
  class: "videobox"
};
const _hoisted_26 = ["src"];
const _hoisted_27 = {
  key: 0,
  class: "videoDesc"
};
const _hoisted_28 = {
  key: 1,
  class: ""
};
const _hoisted_29 = {
  class: "innerbox"
};
const _hoisted_30 = {
  key: 0,
  class: "ul1"
};
const _hoisted_31 = {
  class: "audiobox"
};
const _hoisted_32 = {
  key: 1,
  class: ""
};
const _hoisted_33 = {
  class: "funbox"
};
const _hoisted_34 = {
  key: 0,
  class: "li4"
};
const _hoisted_35 = ["src"];
const _hoisted_36 = {
  key: 1,
  class: "icon-home"
};
const _hoisted_37 = {
  key: 1,
  class: "li2"
};
const _hoisted_38 = ["src"];
const _hoisted_39 = {
  key: 1,
  class: "icon-360"
};
const _hoisted_40 = {
  key: 2,
  class: "li3"
};
const _hoisted_41 = ["src"];
const _hoisted_42 = {
  key: 1,
  class: "icon-topic"
};
const _hoisted_43 = {
  key: 3,
  class: "li1"
};
const _hoisted_44 = {
  key: 4,
  class: "li1"
};
const _hoisted_45 = ["src"];
const _hoisted_46 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_empty = _resolveComponent("el-empty");
  const _component_vue_audio = _resolveComponent("vue-audio");
  const _component_Microphone = _resolveComponent("Microphone");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_Mute = _resolveComponent("Mute");
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", null, [_ctx.$attrs.popshowflag && _ctx.$attrs.detail ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass(["popcontainer-style3", [{
      mobile: _ctx.$attrs.isMobile
    }, {
      useSvw: _ctx.$attrs.id === 1
    }]])
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$attrs.detail.place_name), 1)]), _createElementVNode("div", {
    class: "closediv",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.closePop && $options.closePop(...args))
  }, _cache[7] || (_cache[7] = [_createElementVNode("span", {
    class: "icon-close"
  }, null, -1)]))]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.popLeftArr, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      class: _normalizeClass({
        active: $data.popLeftIndex === item.id
      }),
      key: index,
      onClick: $event => $options.popLeftHandle(item.id)
    }, _toDisplayString(item.name), 11, _hoisted_6);
  }), 128))])]), _createElementVNode("div", _hoisted_7, [_withDirectives(_createElementVNode("div", _hoisted_8, [_withDirectives(_createElementVNode("div", _hoisted_9, [_createElementVNode("div", {
    class: _normalizeClass(["swiper-container swiperbox visibleitem", {
      on: _ctx.$attrs.detail.currentShowtype === 'banner'
    }]),
    ref: "swipercontainer"
  }, [_createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$attrs.detail.banner, (item, i) => {
    return _openBlock(), _createElementBlock("div", {
      class: "swiper-slide",
      key: i
    }, [_createElementVNode("img", {
      src: $options.sethandleHttp(item.fileUrl)
    }, null, 8, _hoisted_11), _createElementVNode("h4", null, [_createElementVNode("span", null, _toDisplayString(i + 1), 1), _cache[8] || (_cache[8] = _createTextVNode("/")), _createElementVNode("span", null, _toDisplayString(_ctx.$attrs.detail.banner.length), 1)])]);
  }), 128))])], 2)], 512), [[_vShow, _ctx.$attrs.detail.banner && _ctx.$attrs.detail.banner.length > 0]]), _createElementVNode("div", _hoisted_12, [_ctx.$attrs.detail.route && _ctx.$attrs.detail.route.length > 0 && Object.keys(_ctx.$attrs.detail.route[0]).length > 1 ? (_openBlock(), _createElementBlock("p", _hoisted_13, [_cache[9] || (_cache[9] = _createElementVNode("span", {
    class: "icon-location1"
  }, null, -1)), _createTextVNode(" " + _toDisplayString($options.getAddress(_ctx.$attrs.detail.route)), 1)])) : _createCommentVNode("", true), _ctx.$attrs.detail.telphone !== undefined && _ctx.$attrs.detail.telphone !== '' ? (_openBlock(), _createElementBlock("p", _hoisted_14, [_createElementVNode("a", {
    href: `tel:${_ctx.$attrs.detail.telphone}`
  }, [_cache[10] || (_cache[10] = _createElementVNode("span", {
    class: "icon-tel"
  }, null, -1)), _createTextVNode(" " + _toDisplayString(_ctx.$attrs.detail.telphone), 1)], 8, _hoisted_15)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", {
    class: "infodesc",
    innerHTML: $options.formatIntroduce(_ctx.$attrs.detail.introduce)
  }, null, 8, _hoisted_17)])], 512), [[_vShow, $data.popLeftIndex === 0]]), _withDirectives(_createElementVNode("div", _hoisted_18, [_ctx.$attrs.detail.video !== '' ? (_openBlock(), _createElementBlock("ul", _hoisted_19, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$attrs.detail.video, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      key: index,
      onClick: $event => $options.videoItemHandle(item)
    }, [_createElementVNode("a", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("img", {
      src: $options.sethandleHttp(item.fileUrl),
      alt: ""
    }, null, 8, _hoisted_23)]), _createElementVNode("h2", null, _toDisplayString(item.title), 1)])], 8, _hoisted_20);
  }), 128))])) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", _hoisted_24, [_createElementVNode("div", {
    class: "closediv",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.closevideoItem && $options.closevideoItem(...args))
  }, _cache[11] || (_cache[11] = [_createElementVNode("span", {
    class: "icon-close"
  }, null, -1)])), _createElementVNode("h2", null, _toDisplayString($data.videoitem.title), 1), _createElementVNode("div", _hoisted_25, [_createElementVNode("video", {
    src: $data.videoitem.url,
    controls: ""
  }, null, 8, _hoisted_26)]), $data.videoitem.desc !== undefined && $data.videoitem.desc !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString($data.videoitem.desc), 1)) : _createCommentVNode("", true)], 512), [[_vShow, $data.videoitemflag && $data.videoitem !== '']]), _ctx.$attrs.detail.video === '' ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_createVNode(_component_el_empty, {
    description: "暂无数据"
  })])) : _createCommentVNode("", true)], 512), [[_vShow, $data.popLeftIndex === 2]]), _withDirectives(_createElementVNode("div", _hoisted_29, [_ctx.$attrs.detail.audio !== '' ? (_openBlock(), _createElementBlock("ul", _hoisted_30, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$attrs.detail.audio, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      key: index
    }, [_createElementVNode("h2", null, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_31, [_createVNode(_component_vue_audio, {
      file: item.url
    }, null, 8, ["file"])])]);
  }), 128))])) : _createCommentVNode("", true), _ctx.$attrs.detail.audio === '' ? (_openBlock(), _createElementBlock("div", _hoisted_32, [_createVNode(_component_el_empty, {
    description: "暂无数据"
  })])) : _createCommentVNode("", true)], 512), [[_vShow, $data.popLeftIndex === 3]])])]), _createElementVNode("ul", _hoisted_33, [_ctx.$attrs.detail.portal_link ? (_openBlock(), _createElementBlock("li", _hoisted_34, [_createElementVNode("a", {
    onClick: _cache[2] || (_cache[2] = $event => $options.goLink(_ctx.$attrs.detail.portal_link)),
    target: "_blank"
  }, [$data.structImgdefaultValues.linkpic1 ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    src: $data.structImgdefaultValues.linkpic1,
    alt: ""
  }, null, 8, _hoisted_35)) : (_openBlock(), _createElementBlock("span", _hoisted_36)), _createTextVNode(" " + _toDisplayString($data.structLabel.portal_link), 1)])])) : _createCommentVNode("", true), _ctx.$attrs.detail.virtual_link ? (_openBlock(), _createElementBlock("li", _hoisted_37, [_createElementVNode("a", {
    onClick: _cache[3] || (_cache[3] = $event => $options.goLink(_ctx.$attrs.detail.virtual_link)),
    target: "_blank"
  }, [$data.structImgdefaultValues.linkpic2 ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    src: $data.structImgdefaultValues.linkpic2,
    alt: ""
  }, null, 8, _hoisted_38)) : (_openBlock(), _createElementBlock("span", _hoisted_39)), _createTextVNode(" " + _toDisplayString($data.structLabel.virtual_link), 1)])])) : _createCommentVNode("", true), _ctx.$attrs.detail.special_link ? (_openBlock(), _createElementBlock("li", _hoisted_40, [_createElementVNode("a", {
    onClick: _cache[4] || (_cache[4] = $event => $options.goLink(_ctx.$attrs.detail.special_link)),
    target: "_blank"
  }, [$data.structImgdefaultValues.linkpic3 ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    src: $data.structImgdefaultValues.linkpic3,
    alt: ""
  }, null, 8, _hoisted_41)) : (_openBlock(), _createElementBlock("span", _hoisted_42)), _createTextVNode(" " + _toDisplayString($data.structLabel.special_link), 1)])])) : _createCommentVNode("", true), _ctx.$attrs.detail.route.length > 0 && _ctx.$attrs.detail.route[0].lng && $data.daohangflag ? (_openBlock(), _createElementBlock("li", _hoisted_43, [_createElementVNode("a", {
    onClick: _cache[5] || (_cache[5] = $event => $options.goLocation(_ctx.$attrs.detail)),
    target: "_blank"
  }, _cache[12] || (_cache[12] = [_createElementVNode("span", {
    class: "icon-location"
  }, null, -1), _createTextVNode("导航")]))])) : _createCommentVNode("", true), _ctx.$attrs.detail.audiodesc && _ctx.$attrs.detail.audiodesc.length > 0 ? (_openBlock(), _createElementBlock("li", _hoisted_44, [_createElementVNode("a", {
    onClick: _cache[6] || (_cache[6] = (...args) => $options.playaudiodesc && $options.playaudiodesc(...args)),
    target: "_blank"
  }, [_withDirectives(_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_Microphone)]),
    _: 1
  }, 512), [[_vShow, !$data.audiodescflag]]), _withDirectives(_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_Mute)]),
    _: 1
  }, 512), [[_vShow, $data.audiodescflag]]), _cache[13] || (_cache[13] = _createTextVNode("语音"))]), _createElementVNode("audio", {
    ref: "audiodesc",
    id: "audiodesc",
    style: {
      "width": "0",
      "height": "0"
    },
    autoplay: "",
    src: _ctx.$attrs.detail.audiodesc[0].url
  }, null, 8, _hoisted_45)])) : _createCommentVNode("", true)])], 2)) : _createCommentVNode("", true), _withDirectives(_createElementVNode("iframe", {
    id: "popiframe",
    src: $data.iframeurl,
    frameborder: "0"
  }, null, 8, _hoisted_46), [[_vShow, $data.linkcontainerflag]]), _withDirectives(_createVNode(_component_el_button, {
    class: "goback",
    onClick: $options.goback,
    round: ""
  }, {
    default: _withCtx(() => _cache[14] || (_cache[14] = [_createTextVNode("返回")])),
    _: 1,
    __: [14]
  }, 8, ["onClick"]), [[_vShow, $data.linkcontainerflag]])]);
}